import React from 'react';
import { motion } from 'framer-motion';

interface IconFlexibleDesignProps {
  className?: string;
}

const IconFlexibleDesign = ({ className }: IconFlexibleDesignProps) => {
  return (
    <svg
      width="243"
      height="233"
      viewBox="0 0 243 233"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ''}
    >
      <path
        d="M101.621 222.469C157.745 222.469 203.242 176.972 203.242 120.848C203.242 64.7239 157.745 19.2266 101.621 19.2266C45.4973 19.2266 0 64.7239 0 120.848C0 176.972 45.4973 222.469 101.621 222.469Z"
        fill="#DEE9F3"
      />
      <mask
        id="mask0_15421_24888"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="19"
        width="204"
        height="204"
      >
        <path
          d="M101.621 222.469C157.745 222.469 203.242 176.972 203.242 120.848C203.242 64.7239 157.745 19.2266 101.621 19.2266C45.4973 19.2266 0 64.7239 0 120.848C0 176.972 45.4973 222.469 101.621 222.469Z"
          fill="#D6E8F6"
        />
      </mask>
      <motion.g
        mask="url(#mask0_15421_24888)"
        initial={{ rotate: 0 }}
        animate={{ rotate: 360 }}
        transition={{ duration: 2, ease: 'linear', repeat: Infinity }}
      >
        <path
          d="M91.8596 91.5934C91.8422 91.6793 91.852 91.7684 91.8877 91.8485C91.9234 91.9285 91.9831 91.9955 92.0586 92.0399L96.4599 94.6371C96.5338 97.0571 97.0023 99.4488 97.8469 101.718L94.7437 105.78C94.6905 105.849 94.6604 105.933 94.6577 106.021C94.655 106.108 94.6798 106.194 94.7287 106.267L98.122 111.376C98.1703 111.449 98.2402 111.505 98.3218 111.536C98.4034 111.567 98.4927 111.572 98.5772 111.55L103.523 110.266C105.288 111.924 107.312 113.283 109.515 114.29L110.192 119.358C110.204 119.445 110.242 119.525 110.302 119.589C110.361 119.653 110.439 119.697 110.525 119.715L116.542 120.933C116.628 120.951 116.717 120.941 116.797 120.905C116.877 120.87 116.944 120.81 116.989 120.734L119.578 116.324C121.999 116.251 124.391 115.783 126.66 114.939L130.731 118.037C130.8 118.091 130.884 118.121 130.972 118.123C131.059 118.126 131.145 118.101 131.218 118.052L136.327 114.659C136.4 114.611 136.456 114.541 136.487 114.46C136.518 114.378 136.523 114.289 136.501 114.204L135.217 109.259C136.875 107.494 138.235 105.471 139.241 103.268L144.31 102.591C144.396 102.579 144.477 102.541 144.541 102.481C144.605 102.421 144.648 102.342 144.665 102.256L145.87 96.2353C145.888 96.1498 145.879 96.0608 145.843 95.981C145.808 95.9011 145.748 95.8344 145.673 95.7903L141.262 93.2005C141.189 90.7801 140.721 88.388 139.877 86.1184L142.98 82.0567C143.033 81.9873 143.063 81.903 143.066 81.8155C143.069 81.7281 143.044 81.642 142.995 81.5694L139.602 76.4603C139.553 76.3876 139.482 76.332 139.4 76.3012C139.318 76.2705 139.228 76.2662 139.144 76.2888L134.198 77.5729C132.433 75.9144 130.41 74.5549 128.208 73.5479L127.53 68.4796C127.518 68.3929 127.48 68.312 127.42 68.2482C127.36 68.1844 127.282 68.141 127.196 68.1241L121.185 66.9102C121.1 66.8925 121.011 66.902 120.931 66.9375C120.851 66.973 120.784 67.0326 120.74 67.108L118.15 71.5182C115.73 71.591 113.338 72.0589 111.068 72.9035L107.007 69.8002C106.937 69.7473 106.853 69.7173 106.765 69.7146C106.678 69.7119 106.592 69.7366 106.519 69.7852L101.41 73.1784C101.338 73.2269 101.282 73.2968 101.251 73.3783C101.22 73.4599 101.215 73.5491 101.236 73.6336L102.521 78.579C100.863 80.3443 99.5035 82.3682 98.497 84.571L93.4288 85.2485C93.3421 85.2601 93.2611 85.2986 93.1974 85.3586C93.1336 85.4185 93.0902 85.4969 93.0733 85.5828L91.8596 91.5934Z"
          fill="#40946A"
        />
        <path
          opacity="0.56"
          d="M112.427 99.1687C111.082 97.5236 110.426 95.4208 110.599 93.3026C110.772 91.1843 111.759 89.2155 113.353 87.81C114.947 86.4045 117.024 85.6717 119.147 85.7658C121.271 85.8599 123.275 86.7735 124.738 88.3145C126.202 89.8556 127.011 91.904 126.996 94.0293C126.981 96.1545 126.142 98.191 124.656 99.7107C123.171 101.23 121.154 102.115 119.029 102.178C116.905 102.242 114.839 101.479 113.265 100.051C112.965 99.7772 112.685 99.4824 112.427 99.1687ZM124.061 89.6486C123.849 89.3905 123.618 89.1487 123.37 88.9251C122.031 87.7087 120.264 87.0741 118.457 87.1609C116.65 87.2476 114.951 88.0486 113.735 89.3876C112.519 90.7267 111.884 92.4941 111.971 94.3011C112.058 96.1081 112.859 97.8066 114.198 99.0229C115.474 100.177 117.139 100.807 118.859 100.786C120.58 100.765 122.229 100.095 123.476 98.9093C124.723 97.7239 125.477 96.111 125.585 94.3936C125.693 92.6763 125.149 90.9815 124.061 89.6486Z"
          fill="white"
        />
      </motion.g>
      <path
        d="M0 214.822H203.298V226.238C203.298 227.767 202.798 229.233 201.908 230.314C201.018 231.395 199.811 232.002 198.553 232.002H4.50452C3.30985 232.002 2.16411 231.426 1.31935 230.4C0.474585 229.373 0 227.981 0 226.53V214.822Z"
        fill="#4B81AC"
      />
      <path
        d="M17.4759 104.191H185.016C187.056 104.191 189.013 104.999 190.456 106.436C191.898 107.872 192.709 109.821 192.709 111.853V216.178H10.4259V111.266C10.4215 110.34 10.6004 109.423 10.9525 108.566C11.3046 107.709 11.8228 106.93 12.4777 106.273C13.1325 105.615 13.911 105.093 14.7687 104.736C15.6264 104.379 16.5463 104.194 17.4759 104.191Z"
        fill="#4B81AC"
      />
      <path
        d="M185.862 111.541H18.7109V210.342H185.862V111.541Z"
        fill="#FBFBFB"
      />
      <path
        d="M115.119 220.869H88.043C86.9384 220.869 86.043 221.765 86.043 222.869V223.034C86.043 224.139 86.9384 225.034 88.043 225.034H115.119C116.223 225.034 117.119 224.139 117.119 223.034V222.869C117.119 221.765 116.223 220.869 115.119 220.869Z"
        fill="#312C36"
      />
      <path
        d="M180.496 117.398H23.4766V203.979H180.496V117.398Z"
        stroke="#413D45"
        strokeWidth="0.415379"
        strokeMiterlimit="10"
      />
      <motion.rect
        x="33.75"
        y="149.684"
        width="39.6216"
        height="24.947"
        rx="1"
        fill="#C1C1C1"
        animate={{ scale: [1, 1.2, 1] }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          repeatDelay: 1,
        }}
      />
      <rect
        x="82.1758"
        y="149.684"
        width="39.6216"
        height="24.947"
        rx="1"
        fill="#C1C1C1"
      />
      <rect
        x="72.7109"
        y="185.088"
        width="59.8802"
        height="9.31469"
        rx="2"
        fill="#413D45"
      />
      <rect
        x="34.1211"
        y="134.283"
        width="59.8802"
        height="5.32268"
        rx="2.66134"
        fill="#413D45"
      />
      <rect
        x="130.602"
        y="149.684"
        width="39.6216"
        height="24.947"
        rx="1"
        fill="#C1C1C1"
      />
      <path
        d="M180.496 117.398H23.4766V125.382H180.496V117.398Z"
        fill="#413D45"
      />
      <path
        d="M29.307 122.71C30.0201 122.71 30.5983 122.131 30.5983 121.418C30.5983 120.705 30.0201 120.127 29.307 120.127C28.5938 120.127 28.0156 120.705 28.0156 121.418C28.0156 122.131 28.5938 122.71 29.307 122.71Z"
        fill="white"
      />
      <path
        d="M33.1859 122.71C33.899 122.71 34.4772 122.131 34.4772 121.418C34.4772 120.705 33.899 120.127 33.1859 120.127C32.4727 120.127 31.8945 120.705 31.8945 121.418C31.8945 122.131 32.4727 122.71 33.1859 122.71Z"
        fill="white"
      />
      <path
        d="M37.4515 122.71C38.1647 122.71 38.7428 122.131 38.7428 121.418C38.7428 120.705 38.1647 120.127 37.4515 120.127C36.7383 120.127 36.1602 120.705 36.1602 121.418C36.1602 122.131 36.7383 122.71 37.4515 122.71Z"
        fill="white"
      />
      <motion.path
        d="M61.424 185.23C61.3567 185.23 61.2899 185.218 61.2261 185.194C61.0941 185.145 60.9891 185.048 60.9337 184.924L58.9423 180.501L56.5755 182.462C56.4761 182.558 56.298 182.626 56.1134 182.626C55.7259 182.626 55.4102 182.33 55.4102 181.964V169.924C55.4102 169.558 55.7259 169.262 56.1134 169.262C56.2774 169.262 56.4364 169.316 56.5712 169.418L65.8546 178.243C65.9995 178.41 66.0555 178.557 66.0555 178.71C66.0555 179.075 65.7397 179.372 65.3522 179.372H62.199L64.1181 183.639C64.2316 183.891 64.1075 184.181 63.8399 184.29L61.6362 185.188C61.5688 185.216 61.4964 185.23 61.424 185.23ZM59.1453 179.168C59.185 179.168 59.224 179.172 59.2638 179.181C59.4305 179.216 59.5697 179.325 59.6357 179.473L61.7058 184.072L62.9329 183.572L60.9067 179.067C60.8372 178.913 60.8549 178.736 60.9535 178.597C61.0523 178.458 61.219 178.374 61.3971 178.374H64.502L56.4747 170.743V181.215L58.7926 179.293C58.8904 179.212 59.0167 179.168 59.1453 179.168ZM55.8856 181.703C55.8707 181.714 55.8573 181.725 55.8444 181.737L55.8856 181.703ZM65.0576 178.902H65.0648H65.0576Z"
        fill="#093E62"
        animate={{ y: [0, 10, 0] }}
        transition={{
          duration: 2,
          ease: 'linear',
          repeat: Infinity,
          repeatDelay: 1,
        }}
      />
      <motion.g
        initial={{ rotate: 0 }}
        animate={{ rotate: 360 }}
        transition={{ duration: 2, ease: 'linear', repeat: Infinity }}
      >
        <path
          d="M153.167 48.9159C153.143 49.0332 153.156 49.155 153.205 49.2643C153.254 49.3735 153.335 49.4649 153.438 49.5257L159.448 53.0718C159.549 56.376 160.188 59.6417 161.342 62.7398L157.105 68.2856C157.032 68.3803 156.991 68.4955 156.987 68.6149C156.983 68.7343 157.017 68.8518 157.084 68.9509L161.717 75.9269C161.783 76.0263 161.879 76.1026 161.99 76.1451C162.101 76.1877 162.223 76.1944 162.339 76.1643L169.091 74.411C171.501 76.675 174.265 78.5307 177.273 79.905L178.198 86.8252C178.214 86.9435 178.266 87.0539 178.347 87.1412C178.429 87.2285 178.535 87.2883 178.652 87.3123L186.868 88.9762C186.985 88.9999 187.107 88.9865 187.216 88.9378C187.325 88.8891 187.417 88.8075 187.477 88.7044L191.013 82.6828C194.318 82.5828 197.584 81.9439 200.683 80.7914L206.241 85.0222C206.335 85.0949 206.451 85.136 206.57 85.1397C206.689 85.1434 206.807 85.1095 206.906 85.0427L213.882 80.4097C213.981 80.3437 214.057 80.2484 214.1 80.1369C214.143 80.0255 214.149 79.9036 214.119 79.7882L212.366 73.0358C214.63 70.6263 216.486 67.8636 217.861 64.8565L224.781 63.9315C224.9 63.9156 225.01 63.863 225.097 63.7811C225.184 63.6993 225.244 63.5922 225.267 63.475L226.912 55.254C226.936 55.1372 226.923 55.0157 226.875 54.9067C226.826 54.7976 226.745 54.7065 226.642 54.6463L220.62 51.1102C220.52 47.8055 219.881 44.5393 218.729 41.4405L222.966 35.8948C223.038 35.8 223.079 35.6848 223.083 35.5654C223.087 35.446 223.053 35.3285 222.986 35.2294L218.353 28.2534C218.286 28.1542 218.19 28.0783 218.078 28.0363C217.966 27.9943 217.843 27.9884 217.727 28.0194L210.975 29.7726C208.566 27.5082 205.803 25.6519 202.796 24.277L201.871 17.3568C201.855 17.2384 201.802 17.1279 201.72 17.0408C201.638 16.9538 201.531 16.8945 201.414 16.8713L193.207 15.214C193.09 15.1897 192.969 15.2027 192.86 15.2512C192.751 15.2996 192.66 15.3811 192.6 15.4841L189.064 21.5056C185.759 21.605 182.493 22.244 179.394 23.3971L173.848 19.16C173.753 19.0876 173.638 19.0467 173.519 19.0431C173.4 19.0394 173.282 19.0731 173.183 19.1394L166.207 23.7725C166.108 23.8387 166.032 23.9341 165.989 24.0454C165.947 24.1567 165.94 24.2785 165.97 24.394L167.723 31.1463C165.459 33.5566 163.604 36.32 162.229 39.3277L155.309 40.2527C155.191 40.2686 155.08 40.3212 154.993 40.403C154.906 40.4849 154.847 40.5919 154.824 40.7092L153.167 48.9159Z"
          fill="#40946A"
        />
        <path
          opacity="0.56"
          d="M181.251 59.2601C179.414 57.0138 178.519 54.1427 178.755 51.2505C178.991 48.3582 180.339 45.67 182.515 43.751C184.692 41.8319 187.528 40.8315 190.427 40.96C193.326 41.0885 196.062 42.3359 198.061 44.4399C200.059 46.544 201.164 49.3409 201.143 52.2427C201.122 55.1445 199.977 57.9251 197.949 60.0001C195.92 62.0751 193.166 63.2828 190.265 63.3694C187.365 63.4559 184.544 62.4146 182.395 60.4643C181.985 60.0908 181.603 59.6884 181.251 59.2601ZM197.135 46.2614C196.846 45.909 196.531 45.5788 196.193 45.2736C194.364 43.6128 191.951 42.7463 189.484 42.8647C187.017 42.9831 184.698 44.0768 183.037 45.9051C181.376 47.7335 180.51 50.1467 180.628 52.6139C180.747 55.0811 181.84 57.4002 183.669 59.061C185.411 60.6374 187.684 61.4974 190.034 61.4686C192.383 61.4398 194.634 60.5245 196.337 58.9059C198.04 57.2873 199.069 55.085 199.217 52.7402C199.365 50.3954 198.621 48.0813 197.135 46.2614Z"
          fill="white"
        />
      </motion.g>
    </svg>
  );
};

export default IconFlexibleDesign;
